import { get } from 'lodash';
// eslint-disable-next-line import/no-unresolved
import AppConfig from 'appconfig';
var reIsoDate = /^(\d{4})-(\d{2})-(\d{2})((T)(\d{2}):(\d{2})(:(\d{2})(\.\d*)?)?)?(Z)?$/;
let parseISODate = function (val) {
    var m;

    m = typeof val === 'string' && val.match(reIsoDate);
    //if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[6] || 0, +m[7] || 0, +m[9] || 0, parseInt((+m[10]) * 1000) || 0));
    if (m) return new Date(+m[1], +m[2] - 1, +m[3], +m[6] || 0, +m[7] || 0, +m[9] || 0, parseInt(+m[10] * 1000) || 0);
    return null;
};

export const host = () => get(AppConfig, ['activeEnvironment', 'host'], window.location.host);

export { parseISODate };
